import {PostCode, IdealPostcodesResponse} from '../models'

export function getPostCodeAddresses(postCode: string): Promise<PostCode> {
    return fetch(`https://api.ideal-postcodes.co.uk/v1/postcodes/${postCode}?api_key=${_IDEAL_POSTCODES_API_KEY_}`)
        .then((r) => r.json())
        .then((data: IdealPostcodesResponse) => ({
            postcode: postCode,
            latitude: data.result?.[0]?.latitude ?? 0,
            longitude: data.result?.[0]?.longitude ?? 0,
            addresses: (data.result || []).map((address) => ({
                line_1: address.line_1,
                line_2: address.line_2,
                line_3: address.line_3,
                town_or_city: address.post_town,
                county: address.county,
                district: address.district,
                country: address.country,
                building_number: address.building_number,
                building_name: address.building_name,
                sub_building_name: address.sub_building_name,
                thoroughfare: address.thoroughfare,
                locality: address.dependant_locality,
                postcode: address.postcode
            }))
        }))
}
